module.exports = __webpack_public_path__ + "img/mobile/Menus-betmenu/stepper_up_purple@2x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/Menus-betmenu/stepper_up_purple@2x.png
// module id = 669
// module chunks = 0